import Joyride, { STATUS, EVENTS, ACTIONS } from "react-joyride";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState, useRef } from "react";
import { useLocation } from 'react-router-dom';
import { resetTour, setTourSteps } from 'store/tour-slice';

const Tour = () => {
    const dispatch = useDispatch();
    const tour = useSelector(state => state.tour)
    const location = useLocation();
    const [ tourActions, setTourActions ] = useState(null);
    const [ tourIndex, setTourIndex ] = useState(0);
    const [ shouldShow, setShouldShow ] = useState(false);
    const [ isShown, setIsShown ] = useState(false);

    const [ waitingForStep, setWaitingForStep ] = useState(null);
    const [ waitingTour, setWaitingTour ] = useState(null);
    const [ secondsWaiting, setSecondsWaiting ] = useState(0);

    const clickHandler = useRef(null);

    useEffect(() => {
        clickHandler.current = handleOnClick;
        if (tour.run === true) {
            if (tourActions && (tour.url === null || tour.url === location.pathname)) {
                if(waitingForStep === null) {
                    setTourIndex(0);
                    
                } else {
                    setTourIndex(waitingForStep);
                    setWaitingForStep(null);
                    setWaitingTour(null);
                    setSecondsWaiting(0);
                }
                setShouldShow(true);
            }
        } else {
            if (tourActions) {
                tourActions.reset(true)
                setIsShown(false);
            }
        }
    }, [ tour, location ])

    useEffect(() => {
        const fn = (e) => {
            if(clickHandler.current) {
                clickHandler.current(e)
            }
        }
        //var elem = document.elementFromPoint(2, 2);
        document.body.addEventListener('click', fn, true); 

        return () => {
            document.body.removeEventListener('click', fn, true);
        }
    }, [])

    useEffect(() => {
        clickHandler.current = handleOnClick;
        
        if (shouldShow && !isShown) {
            sleep(250).then(() => {
                tourActions.reset(true);
                tourActions.open();
                setIsShown(true);
                setShouldShow(false);

            })
        }
    }, [ tourIndex, shouldShow ])

    useEffect(() => {
        if(waitingForStep !== null && waitingTour !== null && secondsWaiting === 0) {
            sleep(500).then(() => {
                setSecondsWaiting(secondsWaiting + 0.5);
            })
        }
    }, [ waitingForStep, waitingTour ])

    useEffect(() => {
        if(waitingForStep !== null && waitingTour !== null && secondsWaiting >= 0) {
            const step = waitingTour.steps[waitingForStep];
            if(step !== undefined) {
                // Find the target element for the step
                const targetElement = document.querySelector(`${step.target}`);
                if(targetElement) {
                    const waitingTourSteps = [...waitingTour.steps];
                    setShouldShow(false);
                    setIsShown(false);
                    dispatch(setTourSteps(waitingTourSteps, waitingTour.url));
                    
                } else {
                    sleep(500).then(() => {
                        setSecondsWaiting(secondsWaiting + 0.5);
                    })
                }
            }
        }
    }, [ waitingForStep, waitingTour, secondsWaiting ])

    const sleep = (ms) => {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    const handleOnClick = (e) => {
        if(tour.run === true) {
            if(tour.steps[tourIndex] !== undefined) {
                const step = tour.steps[tourIndex];
                if(step.target !== undefined) {
                    const targetElement = document.querySelector(`${step.target}`);
                    // console.log(targetElement)
                    // console.log(step);

                    if(targetElement == e.target) {
                        if(step.clickToContinue) {
                            setTourIndex(tourIndex + 1);
                        }
                    }
                }
            }
        }
    }

    const restartTour = () => {
        setTourIndex(0);
        setShouldShow(false);
        setIsShown(false);
        dispatch(resetTour())
    }

    const handleJoyrideCallback = (data) => {
        // console.log(data)
        const { action, index, type, status, lifecycle } = data;

        if ((action === ACTIONS.NEXT && status === STATUS.FINISHED && type === EVENTS.TOUR_END) || (action === ACTIONS.CLOSE && lifecycle === 'complete')) {
            restartTour()
        }

        if(type === EVENTS.TARGET_NOT_FOUND) {
            const step = tour.steps[index];
            if(step) {
                if(step.waitForElement) {
                    setWaitingForStep(index);
                    setWaitingTour({...tour});
                }
            }
        }

        if ([ EVENTS.STEP_AFTER ].includes(type)) {
            // if the current action is 'previous', set the stepIndex back one, otherwise progress +1:
            const stepIndex = index + (action === ACTIONS.PREV ? -1 : 1);
            setTourIndex(stepIndex);
        }
    }

    return <Joyride
        steps={ tour.steps }
        stepIndex={ tourIndex }
        run={ isShown }
        debug={ false }
        continuous={ isShown }
        getHelpers={ (helpers) => {
            setTourActions(helpers)
        }}
        disableScrollParentFix={ true }
        disableScrolling={false}
        callback={ handleJoyrideCallback }
        styles={ {
            options: {
                primaryColor: '#000',
            }
        } } />
}

export default Tour;